var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"e3-svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":Number(_vm.size),"height":Number(_vm.size),"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M7.41 8.58L12 13.17l4.59-4.59L18 10l-6 6-6-6 1.41-1.42z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }